import { api } from './api';

export interface ColonneSaisie {
  uuid: string;
  code: string;
  libelle: string;
  unite: string;
  valeurUnitaire: number | null;
  aide: string | null;
  rang: number;
  active: boolean;
}

export const colonnesSaisie = {
  lister: async (folderUuid: string): Promise<ColonneSaisie[]> =>
    (await api.get('/saisie-client/colonnes', { params: { folderUuid } })).data
      .data,

  enregistrer: async (corps: {
    folderUuid: string;
    uuid?: string;
    code: string;
    libelle: string;
    unite?: string;
    valeurUnitaire?: number | null;
    aide?: string | null;
  }): Promise<ColonneSaisie> =>
    (await api.post('/saisie-client/colonnes', corps)).data.data,

  reordonner: async (
    folderUuid: string,
    uuids: string[]
  ): Promise<ColonneSaisie[]> =>
    (await api.post('/saisie-client/colonnes/ordre', { folderUuid, uuids }))
      .data.data,

  changerEtat: async (uuid: string, active: boolean): Promise<ColonneSaisie> =>
    (
      await api.post(
        `/saisie-client/colonnes/${uuid}/${active ? 'remettre' : 'retirer'}`
      )
    ).data.data,
};
